
namespace Matrix.Rebalancer {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class SummaryViewDialog extends SiteEntityDialog<SummaryViewRow, any> {
        protected getFormKey() { return SummaryViewForm.formKey; }
        protected getIdProperty() { return SummaryViewRow.idProperty; }
        protected getLocalTextPrefix() { return SummaryViewRow.localTextPrefix; }
        protected getNameProperty() { return SummaryViewRow.nameProperty; }
        protected getService() { return SummaryViewService.baseUrl; }

        protected form = new SummaryViewForm(this.idPrefix);

        constructor() {
            super();

            $(window).on('resize.' + this.uniqueName, () => this.arrange());
        }

        destroy() {
            $(window).off('.' + this.uniqueName);
            super.destroy();
        }

        protected afterLoadEntity() {
            super.afterLoadEntity();

            this.form.Columns.viewCode = this.entityId;
            this.form.Formats.viewCode = this.entityId;
            this.form.Instances.viewCode = this.entityId;
            this.form.Accounts.viewCode = this.entityId;
            this.updateInterface();
        }

        protected arrange() {
            super.arrange();
            var availHeight = $(window).height() - 280;
            this.form.Columns.element.css('height', Math.max(150, availHeight) + 'px').trigger('layout');
            this.form.Formats.element.css('height', Math.max(150, availHeight) + 'px').trigger('layout');
            this.form.Instances.element.css('height', Math.max(150, availHeight) + 'px').trigger('layout');
            this.form.Accounts.element.css('height', Math.max(150, availHeight) + 'px').trigger('layout');
        }

        protected updateInterface() {
            super.updateInterface();

            this.form.Columns.set_readOnly(this.form.Columns.get_readOnly() || this.isNew());
            this.form.Formats.set_readOnly(this.form.Formats.get_readOnly() || this.isNew());
            this.form.Instances.set_readOnly(this.form.Instances.get_readOnly() || this.isNew());
            this.form.Accounts.set_readOnly(this.form.Accounts.get_readOnly() || this.isNew());
        }
    }
}